// Superadmin header configuration
export const superadmin_header = [
  {
    id: 1,
    name: "Dashboard",
    icon: "material-symbols-outlined",
    route: "/superadmin/dashboard",
  },
  {
    id: 2,
    name: "Admin",
    icon: "fe fe-users",
    route: "/superadmin/admin",
  },
  {
    id: 2,
    name: "User Detail",
    icon: "fa fa-users",
    route: "/superadmin/All-users",
  },


  {
    id: 4,
    name: "Trade History",
    icon: "fe fe-activity",
    route: "/superadmin/tradehistory",
  },

  {
    id: 5,
    name: "Available Positions",
    icon: "fa fa-home",
    route: "/superadmin/position",
  },

  {
    id: 7,
    name: "Hold off",
    icon: "fe fe-dollar-sign",
    route: "/superadmin/holdoff",
  },
  {
    id: 8,
    name: "Bonus",
    icon: "fe fe-dollar-sign",
    route: "/superadmin/bonus",
  },

  {
    id: 9,
    name: "Withdrawal",
    icon: "fe fe-arrow-down-circle",
    route: "/superadmin/withdrawal",
  },
  {
    id: 10,
    name: "Deposit",
    icon: "fe fe-arrow-up-circle",
    route: "/superadmin/deposit",
  },
  // {
  //   id: 11,
  //   name: "Symbols",
  //   icon: "fe fe-arrow-up-circle",
  //   route: "/superadmin/symbols",
  // },
  {
    id: 12,
    name: "Transfer",
    icon: "fe fe-arrow-up-circle",
    route: "/superadmin/transfer",
  },
];

// Admin header configuration
export const admin_header = [
  {
    id: 1,
    name: "Dashboard",
    icon: "fa-solid fa-house",
    route: "/admin/dashboard",
  },
  {
    id: 2,
    name: "Employees",
    icon: "fe fe-users",
    route: "/admin/employee",
  },
  {
    id: 3,
    name: "Users",
    icon: "fe fe-users",
    route: "/admin/users",
  },
  {
    id: 2,
    name: "User Detail",
    icon: "fa fa-users",
    route: "/admin/all-users-detail",
  },
  {
    id: 4,
    name: "Transaction",
    icon: "fe fe-dollar-sign",
    route: "/admin/transaction",
  },
  // {
  //   id: 5,
  //   name: "Reports",
  //   icon: "fe fe-file-text",
  //   route: "/admin/report",
  // },
  {
    id: 6,
    name: "Trade History",
    icon: "fe fe-activity",
    route: "/admin/tradehistory",
  },
  {
    id: 7,
    name: "Login Status",
    icon: "fe fe-check-square",
    route: "/admin/loginstatus",
  },

  {
    id: 8,
    name: "Available Positions",
    icon: "fe fe-target",
    route: "/admin/position",
  },
  {
    id: 9,
    name: "Withdrawal",
    icon: "fe fe-arrow-down-circle",
    route: "/admin/withdrawal",
  },
  {
    id: 10,
    name: "Deposit",
    icon: "fe fe-arrow-up-circle",
    route: "/admin/deposit",
  },
  {
    id: 11,
    name: "Broadcast",
    icon: "fe fe-arrow-up-circle",
    route: "/admin/broadcast",
  },
  {
    id: 12,
    name: "Hold off",
    icon: "fe fe-arrow-up-circle",
    route: "/admin/holdoff",
  },

  {
    id: 13,
    name: "Bonus",
    icon: "fe fe-arrow-up-circle",
    route: "/admin/bonus",
  },
  {
    id: 14,
    name: "Sign Up",
    icon: "fa fa-dollar-sign",
    route: "/admin/signup",
  },
  {
    id: 15,
    name: "Research",
    icon: "fe fe-check-square",
    route: "/admin/research",
  },
  {
    id: 16,
    name: "Chat-Box",
    icon: "fe fe-check-square",
    route: "/admin/chatbox",
  },
];

export const employee_header = [
  {
    id: 1,
    name: "Dashboard",
    icon: "fa-solid fa-house",
    route: "/employee/dashboard",
  },

  {
    id: 2,
    name: "Users",
    icon: "fe fe-users",
    route: "/employee/users",
  },

  {
    id: 3,
    name: "Available Positions",
    icon: "fe fe-target",
    route: "/employee/position",
  },

  // {
  //   id: 4,
  //   name: "Brokerage",
  //   icon: "fe fe-target",
  //   route: "/employee/brokerage",
  // },
  {
    id: 5,
    name: "Trade History",
    icon: "fe fe-activity",
    route: "/employee/alltradehistory"
  },

];

export const user_header = [
  {
    id: 1,
    name: "Dashboard",
    icon: "fa-solid fa-house",
    route: "/user/dashboard",
  },

  // ⭐ NEW — add after Dashboard
  {
    id: 2,
    name: "Orders",
    icon: "fa-solid fa-list-check",
    route: "/user/orders",
  },

  {
    id: 3,
    name: "Watchlist",
    icon: "fa-solid fa-eye",
    route: "/user/watchlist",
  },

  {
    id: 4,
    name: "Portfolio",
    icon: "fa-solid fa-briefcase",
    route: "/user/portfolio",
  },

  // Existing
  {
    id: 5,
    name: "Option Chain",
    icon: "fa-solid fa-chart-line",
    route: "/user/option-chain",
  },

  {
    id: 6,
    name: "News",
    icon: "fa-solid fa-newspaper",
    route: "/user/news",
  },

  {
    id: 7,
    name: "Research",
    icon: "fa-solid fa-bolt",
    route: "/user/research",
  },

  {
    id: 8,
    name: "Trade Statement",
    icon: "fa-solid fa-file-invoice",
    route: "/user/trade-statement",
  },

  {
    id: 9,
    name: "Ledger Report",
    icon: "fa-solid fa-book",
    route: "/user/ledger-report",
  },

  {
    id: 10,
    name: "Balance Statement",
    icon: "fa-solid fa-wallet",
    route: "/user/balance-statement",
  },

  {
    id: 11,
    name: "Registered Bank",
    icon: "fa-solid fa-building-columns",
    route: "/user/bank-details",
  },

  {
    id: 12,
    name: "KYC Document",
    icon: "fa-solid fa-id-card",
    route: "/user/kyc",
  },
    {
    id: 16,
    name: "Payment History",
    icon: "fa-solid fa-watch ",
    route: "/user/payment-history",
  },

  {
    id: 13,
    name: "Privacy Policy",
    icon: "fa-solid fa-shield-halved",
    route: "/user/privacy-policy",
  },

  {
    id: 14,
    name: "Terms & Conditions",
    icon: "fa-solid fa-scale-balanced",
    route: "/user/terms",
  },

  {
    id: 15,
    name: "Refer & Earn",
    icon: "fa-solid fa-share-nodes",
    route: "/user/refer",
  },

   {
    id: 18,
    name: "Option Chain1",
    icon: "fa-solid fa-chart-line",
    route: "/user/option-chain1",
  },
   {
    id: 17,
    name: "My Favorites",
    icon: "fa-solid fa-right-from-bracket",
    route: "/user/favorites",
  },

  // {
  //   id: 17,
  //   name: "Logout",
  //   icon: "fa-solid fa-right-from-bracket",
  //   route: "/logout",
  // },
];

